// Mercari dispatch bot — what each admin task means, in the admin's words (Thai).
// Backend reasons: backend DISPATCH_BOT.md "adminReason values".

// Owner 2026-11-02: a job is never dropped because nobody bought — every "nobody" task says how to
// keep trying (another buyer, the morning round, buy it yourself). ซื้อไม่ทัน / refund only when sold.
// `todo` = what the admin does, nothing else. {buyer} = the buyer this task is about,
// {minutes} = minutes since their card was sent, {taskMinutes} = minutes since the task appeared.
export const REASONS = {
  direct_buyer: { label: 'สั่งผ่าน FujiKing', color: 'primary', todo: 'สั่งซื้อในเว็บ FujiKing แล้ววางรูปยืนยันการสั่งซื้อ' },
  fallback_buyer: { label: 'สั่งผ่าน FujiKing', color: 'primary', todo: 'สั่งซื้อในเว็บ FujiKing แล้ววางรูปยืนยันการสั่งซื้อ' },
  no_candidate: { label: 'ไม่มีคนกด', color: 'warning', todo: 'ต้องหาคนซื้อให้ได้ · ส่งการ์ดให้คนอื่น (ส่งเลย) · หรือเลื่อนไปส่งตอนเช้า 07:00 · หรือซื้อเองแล้ววางรูปยืนยัน · ยังหาไม่ได้ → ขอให้ North ช่วยหาคนกด (งานยังอยู่บนบอร์ดจนกว่าจะซื้อได้)' },
  all_passed: { label: 'ทุกคนปล่อยผ่าน', color: 'warning', todo: 'ต้องหาคนซื้อให้ได้ · ส่งการ์ดให้คนอื่น (ส่งเลย) · หรือเลื่อนไปส่งตอนเช้า 07:00 · หรือซื้อเองแล้ววางรูปยืนยัน · ยังหาไม่ได้ → ขอให้ North ช่วยหาคนกด (งานยังอยู่บนบอร์ดจนกว่าจะซื้อได้)' },
  outside_hours: { label: 'นอกเวลา', color: 'warning', todo: 'ต้องหาคนซื้อให้ได้ · ส่งการ์ดให้คนอื่น (ส่งเลย) · หรือเลื่อนไปส่งตอนเช้า 07:00 · หรือซื้อเองแล้ววางรูปยืนยัน · ยังหาไม่ได้ → ขอให้ North ช่วยหาคนกด (งานยังอยู่บนบอร์ดจนกว่าจะซื้อได้)' },
  last_no_response: { label: 'คนสุดท้ายไม่ตอบ', color: 'warning', todo: 'ต้องหาคนซื้อให้ได้ · ส่งการ์ดให้คนอื่น (ส่งเลย) · หรือเลื่อนไปส่งตอนเช้า 07:00 · หรือซื้อเองแล้ววางรูปยืนยัน · ยังหาไม่ได้ → ขอให้ North ช่วยหาคนกด (งานยังอยู่บนบอร์ดจนกว่าจะซื้อได้)' },
  pinned_no_response: {
    label: 'คนที่เจาะจงไว้ ยังไม่ซื้อ', color: 'error',
    todo: '{buyer} ยังไม่ซื้อ ผ่านไป {minutes} นาทีแล้ว · ทัก LINE ตาม {buyer} · ไม่ได้จริง → ส่งการ์ดให้คนอื่น (ส่งเลย) หรือเลื่อนไปส่งตอนเช้า 07:00 (การ์ดใหม่ถึง {buyer} คนเดิม) · หรือซื้อเองแล้ววางรูปยืนยัน · ยังหาไม่ได้ → ขอให้ North ช่วยหาคนกด (งานยังอยู่บนบอร์ดจนกว่าจะซื้อได้)',
    // Owner 2026-11-03: negotiated items were bought late because the buyer was away. Sea job, 30
    // minutes after the card with no purchase → the admin checks the item: price lowered and not
    // Exclusive (not reserved for the negotiator) → buy it in FujiKing; Exclusive → chase the
    // buyer again + tell North and Gain. Air: none — we negotiate on our own ID again (same day).
    // Shown loud (filled red box + red board row) because the earlier alert was easy to miss.
    lateAfterMinutes: 30,
    lateFrom: 'card',
    loud: true,
    lateLabelByMode: { sea: 'เกิน 30 นาที → เปิดลิงก์เช็คด่วน' },
    todoLateByMode: {
      sea: '{buyer} ยังไม่ซื้อ เกิน 30 นาทีแล้ว (ผ่านไป {minutes} นาที) · งานเรือ → เปิดลิงก์สินค้าด้านล่าง เช็คว่าคนขายลดราคาให้แล้ว · ไม่ใช่ Exclusive → สั่งในเว็บ FujiKing ได้เลย ไม่ต้องรอ {buyer} แล้วเลือก "ใครเป็นคนซื้อ" เป็น FujiKing วางรูปยืนยันด้านล่าง · เป็น Exclusive → ยังไม่ต้องสั่ง FujiKing ทัก LINE ตาม {buyer} อีกรอบ แล้วแจ้งคุณนอร์ท และคุณเกน',
    },
    // The same steps laid out in parts for the task window (owner 2026-11-03: one long box was hard to read).
    lateStepsByMode: {
      sea: {
        head: '{buyer} ยังไม่ซื้อ ผ่านไป {minutes} นาทีแล้ว',
        first: 'เปิดลิงก์สินค้า เช็คว่าคนขายลดราคาให้แล้ว แล้วดูว่าเป็น Exclusive ไหม',
        branches: [
          { tone: 'go', title: 'ไม่ใช่ Exclusive', action: 'สั่ง FujiKing ได้เลย', lines: ['สั่งในเว็บ FujiKing ไม่ต้องรอ {buyer}', 'เลือก "ใครเป็นคนซื้อ" เป็น FujiKing', 'วางรูปยืนยันการสั่งซื้อด้านล่าง'] },
          { tone: 'stop', title: 'เป็น Exclusive', action: 'ยังไม่ต้องสั่ง FujiKing', lines: ['ทัก LINE ตาม {buyer} อีกรอบ', 'แจ้งคุณนอร์ท และคุณเกน'] },
        ],
      },
    },
  },
  pinned_no_line_group: { label: 'คนกดไม่มีกลุ่ม LINE', color: 'error', todo: 'ตั้งค่ากลุ่ม LINE ของ {buyer} ใน Order By แล้วสร้างงานใหม่' },
  pinned_send_failed: { label: 'ส่งการ์ดไม่สำเร็จ', color: 'error', todo: 'ติดต่อ {buyer} ตรง' },
  // Auctions (owner 2026-11-02): only the account that won can buy, so the bot never sends an auction to the queue.
  auction_unknown_winner: { label: '⚠️ ประมูล เช็คก่อนว่าใครประมูล', color: 'error', todo: '⚠️ สินค้านี้เป็นของประมูล ส่งการ์ดได้เฉพาะคนที่ประมูลชิ้นนี้เท่านั้น บอทยังไม่ส่งให้ใคร · เช็คก่อนว่าใครประมูลชิ้นนี้ด้วยไอดีไหน (กลุ่ม LINE คนกด / หน้าประมูล) · รู้แล้ว → เลือกคนนั้นแล้วกด "ส่งเลย" การ์ดจะไปถึงเขาคนเดียว · ไม่มีใครของเราประมูล → ยกเลิกออเดอร์ที่หน้าออเดอร์ตามปกติ (งานนี้จะปิดเอง)' },
  auction_not_on_sale: { label: '⚠️ ประมูล เช็คก่อนว่าใครประมูล', color: 'error', todo: '⚠️ สินค้านี้เป็นของประมูล ส่งการ์ดได้เฉพาะคนที่ประมูลชิ้นนี้เท่านั้น บอทยังไม่ส่งให้ใคร · Mercari บอกว่าชิ้นนี้ไม่ได้ขายอยู่ เปิดดูในเว็บด้วยว่ายังซื้อได้ไหม · เช็คก่อนว่าใครประมูลชิ้นนี้ด้วยไอดีไหน (กลุ่ม LINE คนกด / หน้าประมูล) · รู้แล้ว → เลือกคนนั้นแล้วกด "ส่งเลย" การ์ดจะไปถึงเขาคนเดียว · ไม่มีใครของเราประมูล หรือซื้อไม่ได้แล้ว → ยกเลิกออเดอร์ที่หน้าออเดอร์ตามปกติ (งานนี้จะปิดเอง)' },
  sold_before_send: { label: 'ซื้อไม่ทัน', color: 'error', todo: 'กรุณายืนยันว่าซื้อไม่ทันจริง ก่อนดำเนินการต่อ · ตรวจในเว็บก่อน · ซื้อไม่ทันจริง → กด "ยืนยันซื้อไม่ทัน" รายการจะเข้าหน้า ดำเนินการยกเลิก (คืนเงินที่นั่น)' },
  sold_nobody_opened: { label: 'ซื้อไม่ทัน', color: 'error', todo: 'กรุณายืนยันว่าซื้อไม่ทันจริง ก่อนดำเนินการต่อ · ตรวจในเว็บก่อน · ซื้อไม่ทันจริง → กด "ยืนยันซื้อไม่ทัน" รายการจะเข้าหน้า ดำเนินการยกเลิก (คืนเงินที่นั่น)' },
  sold_waiting_proof: { label: 'ขายแล้ว รอหลักฐาน', color: 'info', todo: 'รอ {buyer} ส่งหลักฐาน' },
  sold_ask_buyer: { label: 'ขายแล้ว ถามคนกด', color: 'error', todo: 'ทัก LINE ถาม {buyer} ว่ากดไปหรือยัง · กดแล้ว → รอเขาแนบหลักฐาน (หรือวางรูปให้ที่นี่) · ไม่ได้กด → ซื้อไม่ทัน' },
  sold_out_by_clicker: { label: 'คนกดแจ้งของหมด', color: 'error', todo: 'เช็คในเว็บ · ขายแล้ว → ซื้อไม่ทัน · ยังขายอยู่ → ส่งการ์ดให้คนอื่น (ส่งเลย) หรือซื้อเองแล้ววางรูปยืนยัน · ยังหาไม่ได้ → ขอให้ North ช่วยหาคนกด (งานยังอยู่บนบอร์ดจนกว่าจะซื้อได้)' },
  double_proof: { label: 'หลักฐานซ้ำ', color: 'error', todo: 'แจ้งคุณเกนให้จัดการเคสนี้' },
  proof_to_customer: { label: 'แจ้งลูกค้า ซื้อสำเร็จ', color: 'success', todo: 'แจ้งลูกค้าว่ากดซื้อสำเร็จแล้ว พร้อมส่งรูปยืนยันนี้ให้ลูกค้า' },
  buyer_silent: {
    label: 'เปิดดูแล้วเงียบ (Shops)', color: 'error',
    todo: 'ทัก LINE ถาม {buyer} ว่ากดไปหรือยัง · กดแล้ว → รอเขาแนบหลักฐาน (หรือวางรูปให้ที่นี่) · ไม่ได้กด → ส่งต่อคนถัดไป',
    // Still open after this long (the buyer is unreachable) → stop waiting on them: hand the item on.
    lateAfterMinutes: 30,
    todoLate: '{buyer} เปิดดูแล้วไม่ตอบมา {taskMinutes} นาที (Shops) · ส่งต่อคนถัดไป หรือส่งการ์ดให้คนอื่น (ส่งเลย) · หรือซื้อเองแล้ววางรูปยืนยัน · ยังหาไม่ได้ → ขอให้ North ช่วยหาคนกด (งานยังอยู่บนบอร์ดจนกว่าจะซื้อได้)',
  },
};

/** The buyer a task is about: the current card's buyer, else the card the reason points at. */
const buyerName = (job) => {
  const offers = job.offers || [];
  const pick = job.currentOffer?.orderer
    || offers.find((o) => o.openedAt)?.orderer;
  return pick?.label || 'คนกด';
};

export const reasonOf = (job) => {
  const r = REASONS[job.adminReason];
  if (!r) return { label: job.adminReason || job.status, color: 'default', todo: '' };
  const since = (iso) => (iso ? Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000)) : null);
  const minutes = since(job.currentOffer?.sentAt);
  const taskMinutes = since(job.needsAdminAt);
  // lateFrom 'card' = counted from the buyer's card; otherwise from when the task appeared.
  const lateMinutes = r.lateFrom === 'card' ? minutes : taskMinutes;
  const lateText = r.todoLateByMode ? r.todoLateByMode[job.mode] : r.todoLate;
  const late = Boolean(lateText) && lateMinutes != null && lateMinutes >= r.lateAfterMinutes;
  const label = (late && r.lateLabelByMode?.[job.mode]) || r.label;
  const fill = (text) => text
    .replace(/\{buyer\}/g, buyerName(job))
    .replace(/\{minutes\}/g, String(minutes ?? '?'))
    .replace(/\{taskMinutes\}/g, String(taskMinutes ?? '?'));
  const todo = fill(late ? lateText : r.todo);
  const plan = late ? r.lateStepsByMode?.[job.mode] : null;
  const steps = plan ? {
    head: fill(plan.head),
    first: fill(plan.first),
    branches: plan.branches.map((b) => ({ ...b, lines: b.lines.map(fill) })),
  } : null;
  return { ...r, label, todo, steps, late, loud: late && Boolean(r.loud) };
};

export const CARD_STATUS = {
  offered: 'ส่งการ์ดแล้ว (รอ)',
  passed: 'หมดเวลา แต่การ์ดยังใช้ได้',
  expired: 'หมดเวลา การ์ดปิดแล้ว (Shops)',
  engaged: 'เปิดลิงก์แล้ว — รอหลักฐาน (Shops)',
  claimed: 'เปิดหน้าหลักฐาน',
  done: 'ส่งหลักฐานแล้ว ✓',
  closed: 'ปิดแล้ว',
  assigned: 'งานฝั่งแอดมิน (ไม่มีการ์ด)',
  send_failed: 'ส่งการ์ดไม่สำเร็จ',
  sold_out: 'กดว่าของหมด',
  too_big: 'กดว่าชิ้นใหญ่',
  double_proof: 'ส่งหลักฐานซ้ำ',
};

export const MODE = { sea: 'เรือ', air: 'แอร์' };
